// Considered: SegmentedControlAtom directly in the organism — rejected because this
// molecule binds the atom to the source-retrieval model (anchor-aware tab hiding,
// i18n labels, icon mapping). Keeps the organism lean and is reusable.
// See spec Reuse Audit.
import React from 'react';
import { useTranslation } from 'localization';
import SegmentedControlAtom from '../../atoms/SegmentedControl/SegmentedControlAtom';
import './SourceTabsMolecule.scss';

export type SourceMode = 'all' | 'recent' | 'nearby' | 'mine';

export interface SourceTabsMoleculeProps {
  value: SourceMode;
  onChange: (source: SourceMode) => void;
  /** When absent, the Nearby tab is disabled. */
  nearbyAnchorSphereId?: string;
  className?: string;
}

const SourceTabsMolecule: React.FC<SourceTabsMoleculeProps> = ({
  value,
  onChange,
  nearbyAnchorSphereId,
  className = '',
}) => {
  const { t } = useTranslation();

  const options = [
    {
      value: 'all' as SourceMode,
      label: t('sphereChannels.spherePicker.source.all'),
    },
    {
      value: 'recent' as SourceMode,
      label: t('sphereChannels.spherePicker.source.recent'),
      icon: 'pi pi-history',
    },
    {
      value: 'nearby' as SourceMode,
      label: t('sphereChannels.spherePicker.source.nearby'),
      icon: 'pi pi-circle',
      disabled: !nearbyAnchorSphereId,
    },
    {
      value: 'mine' as SourceMode,
      label: t('sphereChannels.spherePicker.source.mine'),
      icon: 'pi pi-user',
    },
  ];

  return (
    <SegmentedControlAtom
      options={options}
      value={value}
      onChange={(v) => onChange(v as SourceMode)}
      mode="single"
      variant="strip"
      size="small"
      className={`source-tabs ${className}`.trim()}
      ariaLabel={t('sphereChannels.spherePicker.source.ariaLabel')}
    />
  );
};

export default SourceTabsMolecule;
